import React, {useContext} from 'react';
import "./ZoomButton.scss";
import "./Adaptations.scss";
import ZoomLoop from "../../../static/img/Union.svg";
import UnZoomLoop from "../../../static/img/Union2.svg";
import {MainContext} from "../../../contexts/MainContext";
import {MapContext} from "../../../contexts/MapContext";

export default function ZoomButton() {
    const {
        setSelectComActive,
        setSelectProActive,
        setSelectActive
    } = useContext(MainContext);

    const {
        zoom,
        defaultZoom,
        toggleZoom
    } = useContext(MapContext);

    return (
        <div
            className="zoom-button"
            onClick={() => {
                setSelectComActive(false);
                setSelectProActive(false);
                setSelectActive(false);
                toggleZoom();
            }}
        >
            <img src={zoom !== defaultZoom ? UnZoomLoop : ZoomLoop} alt="zoom-loop"/>
            <span>zoom</span>
        </div>
    );
};
